import { useState } from 'react';

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'How is this different from traditional publishing?',
      answer: 'Traditional publishing can take years and often requires giving up creative control and most of your royalties. We offer a modern, author-first approach where you maintain full rights, creative control, and higher royalties. Our streamlined process gets your book to market faster while providing professional quality and strategic positioning for long-term success.'
    },
    {
      question: 'Do I keep full rights to my book?',
      answer: 'Absolutely. You retain 100% ownership of your intellectual property, including all rights to your manuscript, cover design, and any derivative works. We believe authors should own their work completely. You\'re free to republish, adapt, or license your book however you choose.'
    },
    {
      question: 'Can you help if my manuscript is unfinished?',
      answer: 'Yes! We work with authors at every stage of the writing process. Whether you need developmental editing to shape your manuscript, ghostwriting support to complete it, or just guidance on structure and content, our team can help you finish your book and prepare it for publication.'
    },
    {
      question: 'Do you provide editing services?',
      answer: 'Yes, we offer comprehensive editorial services including developmental editing, copyediting, and proofreading. Our experienced editors will polish your manuscript while preserving your unique voice and message. Editing services are included in our higher-tier packages or available as add-ons.'
    },
    {
      question: 'Can you help promote my book?',
      answer: 'Absolutely. We offer author branding, press article features, bookstore visibility campaigns, and media positioning strategies. Our goal is to help you build authority and visibility beyond just publishing. We can create a comprehensive launch strategy that positions you as an expert in your field.'
    },
    {
      question: 'Do you offer audiobook services?',
      answer: 'Yes! We provide full audiobook production services, including professional narration, audio engineering, and distribution to major platforms like Audible, Apple Books, and Google Play. Audiobooks are a powerful way to reach more readers and increase your book\'s revenue potential.'
    },
    {
      question: 'Can my book be adapted for film?',
      answer: 'We offer adaptation readiness reviews to evaluate your book\'s potential for screen adaptation. Our team will assess your story structure, characters, and marketability for film or television. We\'ll provide guidance on formatting and positioning your work to attract producers and studios interested in adaptation opportunities.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-gradient-to-b from-black via-[#0A0A0A] to-black py-28">
      <div className="max-w-[1000px] mx-auto px-20">
        <div className="text-center mb-20">
          <div className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] font-medium mb-4">
            Common Questions
          </div>
          <h2 className="text-white text-5xl font-bold mb-5">
            Frequently Asked Questions
          </h2>
          <div className="w-20 h-1 bg-[#D4AF37] rounded-full mx-auto mb-6"></div>
          <p className="text-[#999999] text-lg max-w-2xl mx-auto leading-relaxed">
            Everything you need to know about working with Authority House Publishing.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#1C1C1C] to-[#0F0F0F] rounded-2xl border border-[#D4AF37]/10 overflow-hidden transition-all duration-300 hover:border-[#D4AF37]/30"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-10 py-8 flex items-center justify-between gap-6 text-left cursor-pointer group"
              >
                <div className="flex items-center gap-6 flex-1">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#D4AF37]/10 group-hover:bg-[#D4AF37]/20 transition-all duration-300 flex-shrink-0">
                    <i className="ri-question-line text-[#D4AF37] text-2xl"></i>
                  </div>
                  <h3 className="text-white text-xl font-semibold group-hover:text-[#D4AF37] transition-colors">
                    {faq.question}
                  </h3>
                </div>
                <div className={`w-10 h-10 flex items-center justify-center rounded-lg bg-[#D4AF37]/10 transition-all duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-[#D4AF37] text-2xl"></i>
                </div>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-10 pb-8 pl-[88px]">
                  <div className="border-l-2 border-[#D4AF37]/20 pl-6">
                    <p className="text-[#CCCCCC] text-base leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-[#999999] text-base mb-6">
            Still have questions? We're here to help.
          </p>
          <button className="px-8 py-4 bg-[#D4AF37] text-black font-semibold rounded-xl hover:bg-[#C4A137] transition-all duration-300 whitespace-nowrap cursor-pointer">
            Book a Free Strategy Call
          </button>
        </div>
      </div>
    </section>
  );
}